import { render, staticRenderFns } from "./ImageUploadCropper.vue?vue&type=template&id=64d986a1"
import script from "./ImageUploadCropper.vue?vue&type=script&lang=js"
export * from "./ImageUploadCropper.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadCropper.vue?vue&type=style&index=0&id=64d986a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports